import { Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { sumBy } from 'lodash-es';
import { FC } from 'react';

import { formatNumber } from 'src/utils/common';
import { formatDate } from 'src/utils/date-util';

export interface UnpaidStoreItem {
  key: string;
  storeId: string;
  storeNickname: string;
  settledAt: string;
  invoiceAmount: number;
  unpaidAmount: number;
}

interface UnpaidStoresModalProps {
  open: boolean;
  onClose: () => void;
  items: UnpaidStoreItem[];
  title?: string;
  type?: 'unpaid' | 'overpaid';
}

const UnpaidStoresModal: FC<UnpaidStoresModalProps> = ({
  open,
  onClose,
  items,
  title = '미수 매장 목록',
  type = 'unpaid',
}) => {
  const amountLabel = type === 'unpaid' ? '미납금' : '초과납부금';
  const amountColor = type === 'unpaid' ? 'red' : 'blue';

  const columns: ColumnsType<UnpaidStoreItem> = [
    {
      title: '매장명',
      dataIndex: 'storeNickname',
      key: 'storeNickname',
    },
    {
      title: '정산일',
      dataIndex: 'settledAt',
      key: 'settledAt',
      render: (value: string) => formatDate(value, 'yyyy-MM-dd'),
    },
    {
      title: '청구금액',
      dataIndex: 'invoiceAmount',
      key: 'invoiceAmount',
      align: 'right',
      render: (value: number) => `${formatNumber(value)}원`,
    },
    {
      title: amountLabel,
      dataIndex: 'unpaidAmount',
      key: 'unpaidAmount',
      align: 'right',
      render: (value: number) => (
        <span style={{ color: amountColor }}>{formatNumber(Math.abs(value))}원</span>
      ),
    },
  ];

  return (
    <Modal title={title} open={open} onCancel={onClose} footer={null} width={700}>
      <Table
        columns={columns}
        dataSource={items}
        pagination={false}
        scroll={{ y: 400 }}
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}>
                <b>합계</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} />
              <Table.Summary.Cell index={2} align='right'>
                <b>{formatNumber(sumBy(items, 'invoiceAmount'))}원</b>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} align='right'>
                <b style={{ color: amountColor }}>
                  {formatNumber(Math.abs(sumBy(items, 'unpaidAmount')))}원
                </b>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </Modal>
  );
};

export default UnpaidStoresModal;
